import React from "react"
import { getRequest } from '@helpers/javascript/javascript'

export default class MbcContract extends React.Component {
  constructor(props) {
    super(props)
    this.state = { options: [], loading: false }
  }

  componentDidMount() {
    this.fetchOptions()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.quote.client?.id !== this.props.quote.client?.id) {
      this.fetchOptions()
    }
  }

  fetchOptions() {
    const clientId = this.props.quote.client?.id
    if (!clientId) {
      this.setState({ options: [], loading: false })
      return
    }

    this.setState({ loading: true })
    getRequest(`/mbc_contracts/for_client.json?client_id=${encodeURIComponent(clientId)}`)
      .then(options => this.setState({ options: options || [], loading: false }))
      .catch(error => {
        console.error('Failed to load MBC contracts', error)
        this.setState({ options: [], loading: false })
      })
  }

  onChange(e) {
    const { quote, replaceQuote } = this.props
    const raw    = e.target.value
    const id     = raw === '' ? null : Number(raw)
    const picked = id === null ? null : this.state.options.find(o => o.id === id)
    replaceQuote({
      ...quote,
      mbc_contract:      picked ? { id: picked.id, code: picked.code, title: picked.title } : null,
      mbc_off_bpu_tiers: picked?.off_bpu_tiers || []
    })
  }

  render() {
    const { quote } = this.props
    const { options } = this.state

    // Hide entirely when there is nothing to pick AND nothing currently selected
    if (options.length === 0 && !quote.mbc_contract?.id) return null

    return (
      <div className="form-group">
        <label>{I18n.t("navigation.mbc_contracts")}</label>
        <select
          className="form-control"
          name="quote[mbc_contract_id]"
          value={quote.mbc_contract?.id || ''}
          onChange={this.onChange.bind(this)}
        >
          <option value=""></option>
          {options.map(({ id, label }) => (
            <option key={id} value={id}>{label}</option>
          ))}
        </select>
      </div>
    )
  }
}
